// components/ArticleList.tsx
import React, { } from 'react';
import { Card } from '@mui/material';
import {  useTranslation } from 'next-i18next';
import Texto from '../../Texto';
import { textosPeque } from '@/constants/Dimens'
import Boton from '../../Boton';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';
import TituloDescripcion from '../../TituloDescripcion';
import TextoDescripcion from '../../TextoDescripcion';
import { black,  red, } from '@/constants/Colors';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { Alerta } from '@/objects/Alertas';

interface Props {
  alerta: Alerta;
  onCargar: () => void;
}

const PRECISION = 0.5;

const RowAlerta: React.FC<Props> = ({ alerta, onCargar }) => {

  const { t } = useTranslation();

  const { alertasQueries } = useServices();


  function borrarAlerta() {
    alertasQueries?.borrarAlerta(alerta.id!).then((response: AxiosResponse<number>) => {
      if (response.status == 200) {
        onCargar();
      }
    }
    ).catch((error: any) => {
    });
  }

  return (
    <Card
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between',
        width:
          window.innerWidth < 500 ? "94%" : "500px",
        padding: "20px",
        marginTop: "20px",
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: "100%" }}>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "20px", width: "100%" }}>
           {alerta.titulo_libro &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:subir-libro.titulo_libro')}</TituloDescripcion>
              <TextoDescripcion>{alerta.titulo_libro}</TextoDescripcion>
            </div>
          }
          {alerta.isbn &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.isbn')}</TituloDescripcion>
              <TextoDescripcion>{alerta.isbn}</TextoDescripcion>
            </div>
          }
          {alerta.autor &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.autor')}</TituloDescripcion>
              <TextoDescripcion>{alerta.autor}</TextoDescripcion>
            </div>
          }
          {alerta.editorial &&
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center", alignContent: "center" }}>
              <TituloDescripcion color={black} icon={<LibraryBooksIcon />} >{t('contenido:libro.datos.editorial')}</TituloDescripcion>
              <TextoDescripcion>{alerta.editorial}</TextoDescripcion>
            </div>
          }

          <Texto fontSize={textosPeque}>{dateToTextTForm(alerta.timestamp!, t) + " " + obtenerHoraTForm(alerta.timestamp!)}</Texto>
          <div style={{ display: 'flex', flexDirection: 'column', alignContent: "flex-end", alignItems: "flex-end", width: "100%", marginTop: "10px" }}>
            <Boton color={red} startIcon={<DeleteForeverIcon />} texto={t("common:opciones.borrar")} onClick={borrarAlerta} />
            {/*<Boton fullWidth startIcon={<ReviewsIcon />} texto={t("contenido:subir-libro.editar_resena")} onClick={puntuarUsuario} />*/}
          </div>
        </section>
      </article>
    </Card>
  );
};

export default RowAlerta;
